import { useCallback } from "react";
import { AnalyticsApi, useAPIAction, useCurrentUser } from "melco-shared-logic";

export const useUserWizardAdd = () => {

  const currentUser = useCurrentUser();

  const [addWizards] = useAPIAction(AnalyticsApi,
    async (api, wizardListArr: any) => {
      const data = await api.analytcisManageUserWizards({

        melcoAnalyticsModelsManageUserWidgets: {
          widget_list: wizardListArr
        }
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      defaultApiConfigOptions: { impersonationForId: currentUser?.userId },
      translationPrefix: "dashboard.wizards.actions.add",
    }
  );

  return useCallback(
    async (wizardCode: any) => {
      const successfullyAdded: any[] = [];
      try {
        await addWizards(wizardCode);
        successfullyAdded.push(wizardCode);
      }
      catch (e) {
        // exception already handled in useAPIAction
      }
      return successfullyAdded;
    },
    [addWizards]
  );


}